import { useEffect } from "react";

const SITE_URL = "https://dentcraftnsw.au";

function upsertMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

/**
 * Lightweight, dependency-free SEO head manager for the SPA.
 * Sets title, meta description, robots, canonical, Open Graph/Twitter tags,
 * and an optional page-level JSON-LD schema block.
 */
const Seo = ({ title, description, path = "/", schema }) => {
  useEffect(() => {
    const url = SITE_URL + (path === "/" ? "/" : path);

    if (title) document.title = title;
    if (description) {
      upsertMeta("name", "description", description);
      upsertMeta("property", "og:description", description);
      upsertMeta("name", "twitter:description", description);
    }
    if (title) {
      upsertMeta("property", "og:title", title);
      upsertMeta("name", "twitter:title", title);
    }
    upsertMeta("name", "robots", "index, follow");
    upsertMeta("property", "og:type", "website");
    upsertMeta("property", "og:url", url);
    upsertMeta("name", "twitter:card", "summary_large_image");

    // Canonical
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", url);

    // Page-level JSON-LD schema
    const SCRIPT_ID = "page-jsonld";
    let script = document.getElementById(SCRIPT_ID);
    if (schema) {
      if (!script) {
        script = document.createElement("script");
        script.type = "application/ld+json";
        script.id = SCRIPT_ID;
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(schema);
    } else if (script) {
      script.remove();
    }
  }, [title, description, path, schema]);

  return null;
};

export default Seo;
